import { FormikProps } from 'formik'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useAppDispatch } from 'src/hooks/store'
import { selectCartDetails, selectUserAddress, selectUserType } from 'src/redux/cart/selectors'
import { setCartDetails } from 'src/redux/cart/slice'
import { CartDetails, UserType } from 'src/redux/cart/types'
import { useGetPostalCodes } from 'src/services/api/queries/queries'

export const useUpdateCartDetails = (formik: FormikProps<CartDetails>) => {
  const dispatch = useAppDispatch()
  const cartDetails = useSelector(selectCartDetails)
  const userType = useSelector(selectUserType)
  const userAddress = useSelector(selectUserAddress(userType as UserType))
  const { data } = useGetPostalCodes()

  useEffect(() => {
    const updatedCartDetails = {
      ...cartDetails,
      ...formik.values,
      streetAddress: userAddress?.streetAddress,
      postalCode: userAddress?.postalAddress?.postal_code,
    }
    dispatch(setCartDetails(updatedCartDetails))
  }, [formik.values])
}
